import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconModule } from '@gosuite/icons';
import { LightboxModule } from '@gosuite/lightbox';
import { ButtonModule } from '@gosuite/button';

import { NewsDialogComponent } from './news-dialog.component';
import { NewsDialogService } from './news-dialog.service';


@NgModule({
	declarations: [ NewsDialogComponent ],
	exports: [ NewsDialogComponent ],
	entryComponents: [ NewsDialogComponent ],
	providers: [ NewsDialogService ],
	imports: [
		CommonModule,
		LightboxModule,
		IconModule,
		ButtonModule,
	]
})
export class NewsDialogModule {}



// WEBPACK FOOTER //
// ./src/app/shared/components/news-dialog/news-dialog.module.ts